import {
  PaymentLinkOrderCommentCreateRequestType,
  PaymentLinkOrderCommentCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePaymentLinkOrderCommentCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PaymentLinkOrderCommentCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `payment-link/order-comment`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PaymentLinkOrderCommentCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderComments],
      });
    },
  });
};
